module.exports = __webpack_public_path__ + "img/通威太阳能.6ed6e2e4.png";